export default __webpack_public_path__ + "static/media/8.0c0cdd85.png";